/**
 * @file FAQ
 * @author fengfaxia(fengfaxia@baidu.com))
 * Copyright (c) 2018-11-19 Baidu
 */

import React from 'react';
import {Link} from 'react-router-dom';
import {connect} from 'react-redux';
import {getDwzConsoleUrl} from '../../common/util';
import {setCurrentPage} from '../../actions/generalAction';
import './index.less';

class FAQ extends React.Component {
    linkToApiDoc() {
        this.props.dispatch(setCurrentPage('apidoc'));
    }
    render() {
        const faq = this.props.faq;
        return (
            <div className="container faq-container">
                <h2 className="title">常见问题汇总</h2>
                <ul>
                <div>
                    <li className="question">1、为什么之前生成的短网址跳转很慢？</li>
                    <li className="answer">答：此现象为短网址的延迟跳转，以下情况会导致此现象：<br/>
                        账号余额不足。<br/><br/>解决方案：充值账号或充值账号后购买套餐包即可恢复正常。
                        <span className="font-weight"><br/>建议您在账号中预留一定余额（如100元），避免因未出账的账单导致您再次欠费。</span>
                    </li>
                </div>
                {
                    faq.map(item => (
                        <div>
                            <li className="question">{item.question}</li>
                            <li className="answer">{item.answer}</li>
                        </div>
                    ))
                }
                <div>
                    <li className="question">10、账号还有点数为什么生成不了短网址？</li>
                    <li className="answer">
                        答：请关注短网址内容是否安全合规，如果存在网址内容安全问题，可以提交工单申请人工审核。<br/>
                        咨询类工单：(处置周期1-3个工作日)。<br/>
                        加白类工单：(处置周期1-3个工作日 域名备案信息与公司主体不一致需提供可信授权证明)。<br/>
                        数据类工单：(处置周期3-5个工作日)。
                    </li>
                </div>
                <div>
                    <li className="question">11、百度短网址有效期是多久？</li>
                    <li className="answer">答：目前创建的短网址分一年有效和长期有效。后续有所调整会在百度短网址官网通知大家，请持续关注百度短网址官网动态。</li>
                </div>
                <div>
                    <li className="question">12、在使用百度短连接生成的API接口时，总是提示生成失败，一般失败的原因是什么？</li>
                    <li className="answer">答：请确保请求体是JSON格式，详情请仔细阅读
                        <Link to="/console/apidoc" onClick={() => this.linkToApiDoc()}>"接口文档"</Link>。
                    </li>
                </div>
                <div>
                    <li className="question">13、为什么账号里的套餐包不可用了？</li>
                    <li className="answer">答：以下情况可能导致套餐包不可用：<br/>
                        1）套餐包已过期<br/>
                        2）由于您的套餐包非无缝衔接，在此期间的消费从账号余额中扣除，导致账号欠费；账号欠费状态下套餐包不可用。
                        此种情况，可在<a target="_blank" href="https://console.bce.baidu.com/billing/#/account/index">"财务中心"</a>中查看账号余额（欠款）。
                        欠款缴清后，套餐包即可正常使用。
                        建议在百度云账号中留有一定余额，以免欠费停服。
                    </li>
                </div>
                <div>
                    <li className="question">14、短网址服务可以有效识别真实流量过滤虚假流量，为什么爬虫流量会被计费？</li>
                    <li className="answer">
                        答：爬虫、服务商/运营商扫描等非有效真实流量是会被短网址服务分析处理，短网址服务在识别过程中会消耗一定的服务资源。
                    </li>
                </div>
                <div style={{color: 'red'}}>
                    <li className="question">15、百度短网址服务在微信等APP中被封禁或者弹起中间告警页，怎么解决？</li>
                    <li className="answer">
                        答：这是应用平台自身基于整体安全风险进行的风控行为，和百度短网址服务无关，需要客户自行向APP平台进行申诉解除。
                    </li>
                </div>
                <div style={{color: 'red'}}>
                    <li className="question">16、短链为何会被封禁？</li>
                    <li className="answer">
                        答：短链被封禁的核心原因是内容违规。根据国家法律法规要求，所有短链服务必须对违法违规内容“零容忍”。<br />
                        如果您的短链指向的页面包含以下信息，会被永久封禁：<br />
                        1）涉黄、涉赌、涉诈等违法内容；<br />
                        2）诈骗、虚假宣传、荐股等违规推广；<br />
                        3）侵犯他人权益（如盗版、谣言）。<br />
                        4）刷单欺诈。<br />
                        其他违反公序良俗或法律的行为，平台会通过技术审核和人工排查严格监管，一旦确认违规立即处理。
                    </li>
                </div>
                <div>
                    <li className="question">17、地方运营商短信通道封禁短链怎么办？</li>
                    <li className="answer">
                        答：这种情况可能是运营商安全策略拦截，与服务提供方无关。<br />
                        部分运营商会对短信中的短链加强风控（如高频发送、域名信誉低等），导致链接无法直接访问。建议客户自查短链整改后与短信通道方进行沟通解禁。
                    </li>
                </div>
                <div>
                    <li className="question">18、长链合规但被误封怎么办？</li>
                    <li className="answer">
                        答：若确认长链内容合法但仍被限制，可能是系统误判。请按以下步骤处理：<br/>
                        1）立即反馈：发送长链和短链到ext_dwz-help@baidu.com，或提交工单；<br/>
                        2）提供材料：附上内容合规证明（如备案信息、资质文件）；<br/>
                        3）人工复核：工作人员会在1-3个工作日内审核，若无误将解除封禁。
                    </li>
                </div>
                <div style={{color: 'red'}}>
                    <li className="question">19、账号为何会被封禁？</li>
                    <li className="answer">
                        答：1）恶意使用技术手段造成短网址资源损耗等违法行为。<br/>
                        2）大量链接存在涉黄，涉赌，涉诈、涉荐股等违法内容。<br/>
                        3）通过违规违法的技术手段规避检测，绕过等行为。
                    </li>
                </div>
                {/* <div>
                    <li className="question">14、账号还有点数为什么生成不了短网址？</li>
                    <li className="answer">答：主要有两种情况：<br/>
                        1) 对于免费用户：每个月可创建不超过5条长期有效的短网址。
                        此时账号里剩余的免费点数，用户可以选择创建1年有效的短网址，或者购买套餐包继续创建长期有效的短网址。<br/>
                        2) 对于付费用户：账号欠费时，不能生成短网址，具体参见问题13。
                    </li>
                </div> */}
                </ul>
            </div>
        );
    }
}
FAQ.defaultProps = {
    faq: [
        {
            question: '2、我的短网址刚生成后，可以正常使用。为什么现在却跳转到notfound页面？',
            answer: '答：为保证百度短网址的安全性，短网址服务会定期对您的网页进行安全校验。如果发现页面存在恶意代码、网站欺诈、非法信息等，'
                    + '会删除对应的异常短网址。删除后，访问该短网址会跳转到notfound页面。'
                    + '如果需要申述，请邮件发送申述材料至 ext_dwz-help@baidu.com。'
        },
        {
            question: '3、使用百度短网址接口，请问是否需要任何授权、协议等？',
            answer: '答：为了保证百度短网址的安全性，短网址的接口采用token鉴权机制。每个账号会分配token，即由数字和字母组成的32位字符。在调用API接口时基于token做鉴权。'
        },
        {
            question: '4、百度的短连接生成服务以及API调用是否限制次数？',
            answer: '答：目前短网址生成服务以及API调用面向付费用户是不限制次数的，请放心使用。'
        },
        {
            question: '5、每个用户免费点数是多少？',
            answer: '答：每个用户每月享有100点。'
        },
        {
            question: '6、调用接口的时候返回"user dose not have resource to register long term short url"是什么意思？',
            answer: '答：每个用户每月可免费创建不超过5个长期有效的短网址，超出5个长期有效的短网址，接口将返回'
                    + '"user dose not have resource to register long term short url"。可以充值后继续'
                    + '创建长期有效的短网址，也可以改成创建一年有效的短网址。'
        },
        {
            question: '7、购买套餐后需要重新获取token吗？',
            answer: '答：不需要，可以使用该账号下原有的token。'
        },
        {
            question: '8、个人账号可以开发票吗？',
            answer: '答：可以，百度云个人账号可以开企业普票。500元以下的话，需要发工单开发票。大于500元的，可以直接在百度云控制台中操作。'
        },
        {
            question: '9、账号中的token 有什么作用？',
            answer: '答：一个账号对应一个token。在调用接口时会用来鉴权，为了账号的安全及计费的准确性请勿泄漏token。'
        }
    ]
};

export default connect(state => ({
    currentPage: state.currentPage
}))(FAQ);
